import { z } from 'zod';

// Loose US phone match: optional country code, optional separators/parens.
const US_PHONE_REGEX = /^\+?1?[-.\s]?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;

const usPhoneSchema = z
  .string()
  .trim()
  .min(1, 'This field is required.')
  .regex(US_PHONE_REGEX, 'Enter a valid US phone number.');

/**
 * react-hook-form `validate` rule for PBX line phone fields.
 * Returns `true` when valid, otherwise the error message to display.
 */
export default function validatePbxPhone(value: string) {
  const result = usPhoneSchema.safeParse(value);
  return result.success || result.error.issues[0]?.message || 'Enter a valid US phone number.';
}
